module.exports = __webpack_public_path__ + "assets/img/ic-info-blue.b89dd5d8.svg";